import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import TrackMediaComment from "../../Components/Elements/TrackMediaComment";
import Skeleton from "react-loading-skeleton";

const TrackDetailsWrapper = styled.section`
  position: relative;
  background-color: #f0f0f0;
  overflow: hidden;
  padding: 15px;
  border-right: 1px solid #666;
  border-bottom: 1px solid #666;
  margin-bottom: 10px;
  img {
    display: block;
  }
  // track detail page
  .row-no-media {
    .section-body-comment {
      margin-left: 20px;
    }
  }
  // left side media
  .section-media {
  }

  // right side text
  .section-body-comment {
    padding-left: 0;
    @media (max-width: 767px) {
      padding-left: 20px;
    }
    @media (max-width: 992px) {
      margin-top: 20px;
    }

    .body-comment {
      font-size: 16px;
      white-space: pre-wrap;
      margin-bottom: 15px;
    }
  }
`;

const TrackDetails = ({ loading, track }) => (
  <TrackDetailsWrapper>
    {loading && <Skeleton count={5} />}
    {!loading && <TrackMediaComment track={track} layout="wide" />}
  </TrackDetailsWrapper>
);

TrackDetails.propTypes = {
  loading: PropTypes.bool.isRequired,
  track: PropTypes.object.isRequired,
};

export default TrackDetails;
